/* 
	描述：检查函数
	时间：2020.09.09
	created by sjq
*/

// 数据类型验证
export function bmDataCheck(data, type) {
	if (bmTooljs.judgeType(data) === type) {
		return true
	} else {
		return false
	}
}

export const bmDataCheckjs = {
	// 空验证
	isEmpty: function(data) {
		if (bmDataCheck(data, 'null')) return false
		if (bmDataCheck(data, 'string') || bmDataCheck(data, 'array')) {
			if (data.length === 0) {
				return false
			}
		}
		return true
	},

	// 手机号验证
	isMobileReg: function(val) {
		// var mobileReg = /^((13[0-9])|(19[0-9])|(14[5|7])|(15[0|1|2|3|5|6|7|8|9])|(17[6|7|8])|18[0-9])\d{8}|(170[0|5|9]\d{7})$/
		var mobileReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
		if (mobileReg.test(val)) {
			return true
		} else {
			return false
		}
	},
	// 手机号和座机
	isphoneAndMobile: function(val) {
		var mobileReg = /^([1]\d{10}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?)$/
		if (mobileReg.test(val)) {
			return true
		} else {
			return false
		}
	},

	// 身份证号验证
	isIdCard: function(val) {
		return /^[1-9][0-9]{5}(18|19|(2[0-9]))[0-9]{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)[0-9]{3}[0-9Xx]$/.test(val)
	},

	// 邮箱验证
	isEmail: function(val) {
		return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(val)
	},

	// 电话号码验证
	isPhone: function(val) {
		return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(val)
	},

	// 数字验证
	isNumber: function(val) {
		return Object.prototype.toString.call(val).slice(8, -1) === 'Number'
	},
	// 正整数验证
	isNumberInt: function(val) {
		return /^[+]{0,1}(\d+)$/.test(val)
	},
	//小于1000的正整数
	isNumberLess1000: function(val) {
		return /^(0|([1-9]\d{0,2}))$/.test(val)
	},
	//小于100大于0
	isNumberLess99: function(val) {
		return /^([1-9][0-9]?)$/.test(val)
	},

	// 金额验证
	isLegalAmount: function(val) {
		return /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/.test(val)
	},

	// url验证
	isURL: function(val) {
		return /^http[s]?:\/\/.*/.test(val)
	},
	//网址是否http，https,ftp开头
	isUrlAddress: function(val) {
		return /((http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?)/.test(val)
	},

	// 字符串验证
	isString: function(val) {
		return Object.prototype.toString.call(val).slice(8, -1) === 'String'
	},

	// 日期验证
	isDate: function(str) {
		return /^(\d{4})\-(\d{2})\-(\d{2}) (\d{2})(?:\:\d{2}|:(\d{2}):(\d{2}))$/.test(str) || /^(\d{4})\-(\d{2})\-(\d{2})$/.test(str)
	},

	// 英文验证
	isEnglish: function(str) {
		return /^[a-zA-Z]+$/.test(str)
	},

	// 中文验证
	isChinese: function(str) {
		return /^[\\u4E00-\\u9FA5]+$/.test(str)
	},

	// 大写验证
	isUpper: function(str) {
		return /^[A-Z]+$/.test(str)
	},

	// 小写验证
	isLower: function(str) {
		return /^[a-z]+$/.test(str)
	},

	// 整数且最多保留小数点后两位
	IntegerWithUpToTwoDecimal: function(str) {
		return /^(([1-9])|(0{1}))+(.[0-9]{1,2})?$/.test(str)
	},

	// 整数最多保留18位，小数位保留两位以内
	isIntegertoDecimal18: function(str) {
		return /^\d{1,18}$|^\d{1,18}[.]\d{1,2}$/.test(str)
	},

	// 检测密码强度
	checkPwd: function(str) {
		var Lv = 0
		if (str.length < 6) {
			return Lv
		}
		if (/[0-9]/.test(str)) {
			Lv++
		}
		if (/[a-z]/.test(str)) {
			Lv++
		}
		if (/[A-Z]/.test(str)) {
			Lv++
		}
		if (/[\.|-|_]/.test(str)) {
			Lv++
		}
		return Lv
	},

	// 检查小数
	checkDecimal: function() {
		return str.match(/ ^-?\d+(\.\d+)?$/g) === null
	},

	// 最大最小长度检查
	maxMinLength: function(data, max, min) {
		data = parseInt(data)
		if (isNaN(data)) {
			data = 0
		}
		if (data > parseInt(max)) {
			return false
		}
		if (data < parseInt(min)) {
			return false
		}
		return true
	},

	// 字符长度检查
	lengthCheck: function(data, length) {
		if (bmDataCheck(data, 'array')) {
			return !data.length > length
		} else {
			data = data.toString()
			if (bmDataCheck(data, 'string')) {
				return !data.length > length
			} else {
				return false
			}
		}
	},
	// 组织机购代码
	isCoderight: function(str) {
		return /^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$/.test(str)
		//兼容 15 位及 18位 /(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)|(^\d{15}$)/
	},
	// 判断公司名称，不能全部为空格
	isEmptyAllright: function(str) {
		return /^(?!(\s+$))/.test(str)
	},

	// 验证集合
	checkStr: function(str, type) {
		switch (type) {
			case 'mobile': // 手机号码
				return /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(str)
			case 'phone': // 座机
				return /^(0\d{2,3}-\d{7,8})(-\d{1,4})?$/.test(str)
			case 'idCard': // 身份证
				return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(str)
			case 'pwd': // 密码以字母开头，长度在6~18之间，只能包含字母、数字和下划线
				return /^[a-zA-Z]\w{5,17}$/.test(str)
			case 'postal': // 邮政编码
				return /[1-9]\d{5}(?!\d)/.test(str)
			case 'QQ': // QQ号
				return /^[1-9][0-9]{4,9}$/.test(str)
			case 'email': // 邮箱
				return /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(str)
			case 'money': // 金额(小数点2位)
				return /^\d*(?:\.\d{0,2})?$/.test(str)
			case 'url': // 网址
				return /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test(str)
			case 'ip': // IP
				return /((?:(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d)\\.){3}(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d))/.test(str)
			case 'date': // 日期时间
				return /^(\d{4})\-(\d{2})\-(\d{2}) (\d{2})(?:\:\d{2}|:(\d{2}):(\d{2}))$/.test(str) || /^(\d{4})\-(\d{2})\-(\d{2})$/.test(str)
			case 'number': // 数字
				return /^[0-9]$/.test(str)
			case 'english': // 英文
				return /^[a-zA-Z]+$/.test(str)
			case 'chinese': // 中文
				return /^[\\u4E00-\\u9FA5]+$/.test(str)
			case 'lower': // 小写
				return /^[a-z]+$/.test(str)
			case 'upper': // 大写
				return /^[A-Z]+$/.test(str)
			case 'HTML': // HTML标记
				return /<("[^"]*"|'[^']*'|[^'">])*>/.test(str)

			default:
				return true
		}
	},

	// 发送数据检查
	sendDataCheck: function(data, rule) {
		var pass = true
		var validator = [
			'isEmpty',
			'isMobileReg',
			'isIdCard',
			'isEmail',
			'isPhone',
			'isNumber',
			'isURL',
			'isString',
			'isChinese',
			'isEnglish',
			'isDate',
			'isPostal',
			'isUpper',
			'isLower'
		]
		var resultList = []
		if (bmDataCheck(data, 'array')) {
			for (var i = 0; i < data.length; i++) {
				if (bmDataCheck(data[i], 'object')) {
					Object.keys(data[i]).map(function(x) {
						rule.map(function(y) {
							if (x === y.keyName) {
								var validatorNameList = y.validatorName.split(',')
								validatorNameList.map(function(z) {
									if (validator.indexOf(bmTooljs.spaceFilter(z)) !== -1) {
										if (!bmDataCheckjs[bmTooljs.spaceFilter(z)](data[i][x])) {
											resultList.push({
												keyName: x,
												validator: z + '不合法'
											})
											pass = false
										}
									} else {
										resultList.push({
											keyName: x,
											validator: z + '不是一个合法的检测函数'
										})
										pass = false
									}
								})
							}
						})
					})
				} else {
					console.error('sendDataCheck: 参数第' + i + '项不是一个对象, type: ' + bmTooljs.judgeType(data))
				}
			}
		}

		if (bmDataCheck(data, 'object')) {
			Object.keys(data).map(function(x) {
				rule.map(function(y) {
					if (x === y.keyName) {
						var validatorNameList = y.validatorName.split(',')
						validatorNameList.map(function(z) {
							if (validator.indexOf(bmTooljs.spaceFilter(z)) !== -1) {
								if (!bmDataCheckjs[bmTooljs.spaceFilter(z)](data[x])) {
									resultList.push({
										keyName: x,
										validator: z + '不合法'
									})
									pass = false
								}
							} else {
								resultList.push({
									keyName: x,
									validator: z + '不是一个合法的检测函数'
								})
								pass = false
							}
						})
					}
				})
			})
		}

		// if (!bmDataCheck(data, 'array') || !bmDataCheck(data, 'object')) {
		//     console.error('sendDataCheck: 参数类型错误, 只接受数组对象和纯对象形式的参数')
		//     return
		// }

		return {
			pass: pass,
			result: resultList
		}
	},

	// 对象属性检查
	objKeyscheck: function(data, path) {}
}



//////////////////
// WEBPACK FOOTER
// ./static/commonplugin/dataCheck.js
// module id = Dqes
// module chunks = 13